<template>
	<div class="pages" v-loading="listLoading">
		<div v-for='(item, index) in this.templateData.TemplateContent.Controls' :key='index'>
			<Digit v-if='item.Property.Control == "Number"' :data-val='item'></Digit>
			<Contact v-if='item.Property.Control == "Condition"' :data-val="item"></Contact>
			<Dates v-if='item.Property.Control == "Date"' :data-val="item"></Dates>
			<Version v-if='item.Property.Control == "Text"' @child-event='getTextVal' :data-val="item"></Version>
			<Money v-if='item.Property.Control == "Money"' :data-val="item"></Money>
			<Tips v-if='item.Property.Control == "Tips"' :data-val="item"></Tips>
			<File v-if='item.Property.Control == "File"' :data-val="item"></File>
			<Table v-if='item.Property.Control == "Table"' @child-event='tableOperation' :data-val='item'></Table>
			<Selector v-if='item.Property.Control == "Selector"' @child-event='getSelectorVal' :data-val='item'>
			</Selector>
			<Textarea v-if='item.Property.Control == "Textarea"' :data-val='item'></Textarea>
			<Choose v-if='item.Property.Control == "Contact"' @child-event='clickChoose' :data-val='item'></Choose>
		</div>
		<Button class="submit-process" v-on:click='submit' v-bind:disabled="isDisabled" v-bind:loading="formLoading"
			size="large" type="primary"> 提交
		</Button>
	</div>
</template>

<script>
import Digit from '../components/Number.vue'
import Contact from '../components/Contact.vue';
import Dates from '../components/Date.vue';
import Version from '../components/Text.vue';
import Money from '../components/Money.vue';
import Tips from '../components/Tips.vue';
import File from '../components/File.vue';
import Table from '../components/Table.vue';
import Selector from '../components/Selector.vue';
import Textarea from '../components/Textarea.vue';
import stringUtils from "../assets/js/stringUtil.js";
import Choose from '../components/Choose.vue';
import wx from 'weixin-js-sdk'
import {
	initWxConfig
} from '../api/jssdk.js';
import { getTemplateInfo, submitProcess, AllowApplyForVerify } from '@/api/approval'
import {
	getRelation
} from '@/api/employee'
var template = {
	TemplateContent: {
		Controls: []
	}
};
var isSubmit = false;
export default {
	components: {
		Contact,
		Dates,
		Version,
		Money,
		Tips,
		File,
		Table,
		Digit,
		Selector,
		Textarea,
		Choose
	},
	data() {
		return {
			templateData: template,
			relationList: null,
			logInfo: null,
			templateId: "",
			spNo: null,
			flowId: null,
			listLoading: false,
			isDisabled: false,
			formLoading: false,
			relationData: []
		}
	},
	created() {
		initWxConfig(this);
		this.logInfo = this.getLoginUserInfo();
		this.templateId = this.$route.query.templateId;
		this.spNo = this.$route.query.spNo;
		this.getEmployeeRelation(this.logInfo.EmpNo);
		stringUtils.setAddIsShow(true);
	},
	methods: { //方法

		clickChoose: async function (dataVal, name) {
			var that = this;
			window.wx.invoke("selectEnterpriseContact", {
				"fromDepartmentId": 0, // 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
				"mode": "single", // 必填，选择模式，single表示单选，multi表示多选
				"type": ["user"], // 必填，选择限制类型，指定department、user中的一个或者多个
				"selectedDepartmentIds": [], // 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
				"selectedUserIds": [] // 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
			}, async function (res) {
				if (res.err_msg == "selectEnterpriseContact:ok") {
					if (typeof res.result == 'string') {
						res.result = JSON.parse(res.result) //由于目前各个终端尚未完全兼容，需要开发者额外判断result类型以保证在各个终端的兼容性
					}
					var title = that.logInfo.fullName;
					console.log(title)
					var user = res.result.userList[0];
					dataVal.Values = [];
					dataVal.Values.push([user.id, user.name]);
					dataVal.Value = user.name;
					if (title.indexOf("住宅行政支持组") > -1) {
						if (user.id == that.logInfo.EmpNo) {
							that.templateData.TemplateContent.Controls.forEach((item) => {
								if (item.Property.Title[0].Text == "所在部门") {
									item.Value = item.Config.Selector.Options.filter(o => { return o.Value[0].Text == "住宅行政支持组" })[0].Key;
								}
							});
							return;
						}
						await that.getEmployeeRelation(user.id);
						that.templateData.TemplateContent.Controls.forEach((item) => {
							if (item.Property.Title[0].Text == "大区董事") {
								item.Values = that.findEmpByPositionName(that.relationList, "高级大区董事", 7);
								if (item.Values == null || item.Values.length <= 0) {
									//审批节点无人，跳过
									item.Values.push(that.$store.state.defaultMember);
								}
							}
							if (item.Property.Title[0].Text == "店董") {
								item.Values = that.findEmpByPositionName(that.relationList, "店董");
								if (item.Values == null || item.Values.length <= 0) {
									//审批节点无人，跳过
									item.Values.push(that.$store.state.defaultMember);
								}
							}
							if (item.Property.Title[0].Text == "区域董事") {
								item.Values = that.findEmpByPositionName(that.relationList, "区域董事");
								if (item.Values == null || item.Values.length <= 0) {
									//审批节点无人，跳过
									item.Values.push(that.$store.state.defaultMember);
								}
							}
							if (item.Property.Title[0].Text == "大区总经理") {
								item.Values = that.findEmpByPositionName(that.relationList, "总经理", 8);
								if (item.Values == null || item.Values.length <= 0) {
									//审批节点无人，跳过
									item.Values.push(that.$store.state.defaultMember);
								}
							}

							if (item.Property.Title[0].Text == "逐级审批使用") {
								item.Values = that.getRelationList(that.relationList, 6);
								item.Values = that.applyZhujishenpiValues(item.Values, "SalaryManager", { fullName: that.logInfo.fullName });
								if (item.Values == null || item.Values.length <= 0) {
									//审批节点无人，跳过
									item.Values.push(that.$store.state.defaultMember);
									console.log('逐级审批2', item.Values)
								}
							}
						});


						//总体人员离职临时控制
						that.replaceAthor(that.templateData.TemplateContent.Controls);
						

					}
				}
			})
		},
		getTemplate: async function () {
			var title = this.logInfo.fullName;
			// if(title=="华西区/四川中原物业顾问有限公司"){
			// 	this.Message({
			// 		message: '没有申请权限',
			// 		type: 'error',
			// 		duration: 1000
			// 	});
			// 	this.isDisabled = true;
			// }
			this.listLoading = true;
			getTemplateInfo(this.templateId).then(async response => {
				var that = this;
				var controls = response.Body;
				var title = this.logInfo.fullName;
				var departs = this.logInfo.fullName.split("/");
				controls.TemplateContent.Controls.forEach(async (item) => {
					if (item.Property.Title[0].Text == "部门 ") {
						item.Option = Object.keys(that.relationData);
						if (departs.indexOf("华西区") > -1) {
							item.Value = departs[departs.indexOf("华西区") + 1] + "/" + that.logInfo.DeptName;
						} else if (departs.indexOf("非营业部") > -1 || departs.indexOf("原友信") > -1) {
							item.Value = departs[departs.indexOf("非营业部") + 1] + "/" + that.logInfo.DeptName;
						} else if (departs.indexOf("营业部") > -1) {
							item.Value = departs[departs.indexOf("营业部") + 1] + "/" + that.logInfo.DeptName;
						} else if (departs.indexOf("其他") > -1) {
							item.Value = departs[departs.indexOf("其他") + 1] + "/" + that.logInfo.DeptName;
						}
						if (that.relationData.length > 0) {
							that.relationList = that.relationData[item.Value];
						}

					}
					if (item.Property.Title[0].Text == "所在部门") {
						if (departs.indexOf("非营业部") > -1 || departs.indexOf("原友信") > -1) {
							item.Value = item.Config.Selector.Options.filter(o => { return o.Value[0].Text == "非营业部" })[0].Key;
						}
						else if (departs.indexOf("房友圈") > -1 || departs.indexOf("藤云") > -1) {
							item.Value = item.Config.Selector.Options.filter(o => { return o.Value[0].Text == "房友圈" })[0].Key;
						}
						else if (departs.indexOf("住宅行政支持组") > -1) {
							item.Value = item.Config.Selector.Options.filter(o => { return o.Value[0].Text == "住宅行政支持组" })[0].Key;
						}

						else if (departs.indexOf("住宅部") > -1) {
							item.Value = item.Config.Selector.Options.filter(o => { return o.Value[0].Text == "住宅部" })[0].Key;
						}
						else if (departs.indexOf("按揭金融服务中心") > -1) {
							item.Value = item.Config.Selector.Options.filter(o => { return o.Value[0].Text == "汇瀚" })[0].Key;
						}
						else if (departs.indexOf("二级市场营运中心") > -1 || departs.indexOf("代理") > -1) {
							item.Value = item.Config.Selector.Options.filter(o => { return o.Value[0].Text == "二级市场营运中心/代理" })[0].Key;
						}
						else if (departs.indexOf("工商铺商业运营中心") > -1) {
							item.Value = item.Config.Selector.Options.filter(o => { return o.Value[0].Text == "工商铺商业运营中心" })[0].Key;
						} else {
							item.Value = item.Config.Selector.Options.filter(o => { return o.Value[0].Text == "非营业部" })[0].Key;
						}
						item.Disable = true;
						item.IsShow = false;
					}
					if (item.Property.Title[0].Text == "流程编号") {
						item.IsShow = false;
					}
					if (item.Property.Title[0].Text == "请选择审批行政助理") {
						if (departs.indexOf("住宅部") > -1 || departs.indexOf("住宅行政支持组") > -1) {
							item.IsShow = true;
							if (departs.indexOf("住宅行政支持组") > -1) {
								item.Property.Title[0].Text = "请选择营业部人员";
							}
						} else {
							item.Values = [];
							item.Values.push(that.$store.state.defaultMember);
							item.Value = "默认总经理"
							item.IsShow = false;
						}
					}
					if (item.Property.Title[0].Text == "大区董事") {
						item.IsShow = false;
						item.Values = [];
						item.Values = that.findEmpByPositionName(that.relationList, "高级大区董事", 7);
						if (item.Values == null || item.Values.length <= 0) {
							//审批节点无人，跳过
							item.Values.push(that.$store.state.defaultMember);
						}
					}
					if (item.Property.Title[0].Text == "店董") {
						item.IsShow = false;
						item.Values = [];
						item.Values = that.findEmpByPositionName(that.relationList, "店董");
						if (item.Values == null || item.Values.length <= 0) {
							//审批节点无人，跳过
							item.Values.push(that.$store.state.defaultMember);
						}
					}
					if (item.Property.Title[0].Text == "区域董事") {
						item.IsShow = false;
						item.Values = [];
						item.Values = that.findEmpByPositionName(that.relationList, "区域董事");
						if (item.Values == null || item.Values.length <= 0) {
							//审批节点无人，跳过
							item.Values.push(that.$store.state.defaultMember);
						}

					}
					if (item.Property.Title[0].Text == "大区总经理") {
						item.IsShow = false;
						item.Values = [];
						if (departs.indexOf("住宅部") > -1) {
							item.Values = that.findEmpByPositionName(that.relationList, "总经理", 8);
						}
						if (item.Values == null || item.Values.length <= 0) {
							//审批节点无人，跳过
							item.Values.push(that.$store.state.defaultMember);
						}
					}
					if (item.Property.Title[0].Text == "逐级审批使用") {
						item.Values = [];
						item.IsShow = false;
						item.Values.push(that.$store.state.defaultMember);
						if (departs.indexOf("非营业部") > -1 || departs.indexOf("原友信") > -1) {
							if (departs.indexOf("原友信") > -1) {
								item.Values = that.getRelationList(that.relationList, 7);
								if (item.Values === null || item.Values.length <= 0) {
									item.Values.push(["SC23000338", "蒋燕"])
								}
							} else {
								item.Values = that.getRelationList(that.relationList, 8);
								for (var i = item.Values.length - 1; i > -1; i--) {
									if (item.Values[i][0] == 'SC02120002') {
										item.Values.splice(i, 1)
									}
								}
							}
							console.log('逐级审批3', item.Values)
						}
						else if (departs.indexOf("二级市场营运中心") > -1 || departs.indexOf("代理") > -1) {
							item.Values = that.getRelationList(that.relationList, 8);
						}
						else if (departs.indexOf("住宅部") > -1) {
							item.Values = that.getRelationList(that.relationList, 6);
						}
						else if (departs.indexOf("工商铺商业运营中心") > -1) {
							item.Values = that.getRelationList(that.relationList, 6);
						}
						else if (departs.indexOf("按揭金融服务中心") > -1) {
							item.Values = that.getRelationList(that.relationList, 7);
						}

						else if (departs.indexOf("房友圈") > -1) {
							item.Values = that.getRelationList(that.relationList, 7);
						}


						item.Values = that.applyZhujishenpiValues(item.Values, "SalaryManager", { fullName: that.logInfo.fullName });
						if (item.Values == null || item.Values.length <= 0) {
							//审批节点无人，跳过
							item.Values.push(that.$store.state.defaultMember);
						}
					}
					if (item.Property.Title[0].Text == "冻结原因详情") {
						item.IsShow = false;
					}
				});
				that.templateData = that.assignControl(controls, that.logInfo);
				var controlR = await that.assignControlBySpNo(controls, that.spNo);
				
				that.templateData = that.replaceAthor(controlR);
				that.listLoading = false;
			});
		},
		//总体人员离职临时控制
		replaceAthor: function (controls) {
			var that = this;
			var replaceData = that.getZhujishenpiReplaceData("SalaryManager");
			controls.TemplateContent.Controls.forEach(item => {
				replaceData.forEach(ditem => {
					if (Array.isArray(item.Values)) {
						item.Values.forEach((subArr, i) => {
							if (Array.isArray(subArr) && subArr.includes(ditem.old)) {
								that.$set(item.Values, i, [ditem.new, ditem.name]);
							}
						});
					}
				});
			});
			console.log('总体人员离职临时控制',controls);
			return controls;
		},
		getEmployeeRelation: async function (empNo) {
			var that = this;
			await getRelation(empNo).then(response => {
				that.relationList = response.Body[0].Nodes;
				var departs = that.logInfo.fullName.split("/");
				if (response.Body.length > 1) {
					for (var i = 0; i < response.Body.length; i++) {
						var name1 = "";
						var name = response.Body[i].Nodes[0].DeptName;
						if (response.Body[i].Nodes.length > 1) {
							for (var j = 0; j < response.Body[i].Nodes.length; j++) {
								var node = response.Body[i].Nodes[j];
								if (node.DeptName.indexOf("华西区") > -1) {
									name1 = response.Body[i].Nodes[j - 1].DeptName + "/";
									break;
								} else if (node.DeptName.indexOf("非营业部") > -1 || node.DeptName.indexOf("原友信") > -1) {
									name1 = response.Body[i].Nodes[j - 1].DeptName + "/";
									break;
								} else if (node.DeptName.indexOf("营业部") > -1) {
									name1 = response.Body[i].Nodes[j - 1].DeptName + "/";
									break;
								} else if (node.DeptName.indexOf("代理") > -1) {
									name1 = response.Body[i].Nodes[j].DeptName + "/";
									break;
								} else if (node.DeptName.indexOf("其他") > -1) {
									name1 = response.Body[i].Nodes[j - 1].DeptName + "/";
									break;
								} else {
									name1 = response.Body[i].Nodes[j - 1].DeptName + "/";
									break;
								}
							}


						}
						that.relationData[name1 + name] = response.Body[i].Nodes;
					}
				}

			});


		},
		getTextVal(val, option) {
			if (option != null && option == 'Option') {
				var that = this;
				var controls = this.templateData.TemplateContent.Controls;
				that.relationList = that.relationData[val];
				controls.forEach(async (item) => {
					var departs = this.logInfo.fullName.split("/");
					if (item.Property.Title[0].Text == "逐级审批使用") {
						item.Values = [];
						item.IsShow = false;
						item.Values.push(that.$store.state.defaultMember);
						if (departs.indexOf("非营业部") > -1 || departs.indexOf("原友信") > -1) {
							if (departs.indexOf("原友信") > -1) {
								item.Values = that.getRelationList(that.relationList, 7);
								if (item.Values === null || item.Values.length <= 0) {
									item.Values.push(["SC23000338", "蒋燕"])
								}
							} else {
								item.Values = that.getRelationList(that.relationList, 8);
								for (var i = item.Values.length - 1; i > -1; i--) {
									if (item.Values[i][0] == 'SC02120002') {
										item.Values.splice(i, 1)
									}
								}
							}

						}
						else if (departs.indexOf("二级市场营运中心") > -1 || departs.indexOf("代理") > -1) {
							item.Values = that.getRelationList(that.relationList, 8);
						}
						else if (departs.indexOf("住宅部") > -1) {
							item.Values = that.getRelationList(that.relationList, 6);
						}
						else if (departs.indexOf("工商铺商业运营中心") > -1) {
							item.Values = that.getRelationList(that.relationList, 6);
						}
						else if (departs.indexOf("按揭金融服务中心") > -1) {
							item.Values = that.getRelationList(that.relationList, 7);
						}

						else if (departs.indexOf("房友圈") > -1) {
							item.Values = that.getRelationList(that.relationList, 7);
						}


						item.Values = that.applyZhujishenpiValues(item.Values, "SalaryManager", { fullName: that.logInfo.fullName });
						if (item.Values == null || item.Values.length <= 0) {
							//审批节点无人，跳过
							item.Values.push(that.$store.state.defaultMember);
						}
						console.log('逐级审批1', item.Values)
					}
				});
			}
		},
		getSelectorVal(val, name) {
			var type = "";
			var y = 0;
			var children = "";
			var controls = this.templateData.TemplateContent.Controls;
			var controlInfo = controls.filter(item => item.Property.Title[0].Text == name)[0];
			//申请类型事件
			if (name == "申请类型") {

				var isSendout = false;
				var isBlock = false;
				var isDeduction = false;
				var optionType = controlInfo.Config.Selector.Options
					.filter(item => {
						return item.Key == val;
					})[0];
				if (optionType.Value[0].Text == "发放") {
					isSendout = true;
				}
				if (optionType.Value[0].Text == "冻结") {
					isBlock = true;
				}
				if (optionType.Value[0].Text == "扣减") {
					isDeduction = true;
				}
				controls.filter(item => item.Property.Title[0].Text == "申请冻结原因")[0].Property.Require = isBlock ? 1 : 0;
				controls.filter(item => item.Property.Title[0].Text == "冻结原因详情")[0].Property.Require = isBlock ? 1 : 0;
				controls.filter(item => item.Property.Title[0].Text == "申请发放原因")[0].Property.Require = isSendout ? 1 : 0;
				controls.filter(item => item.Property.Title[0].Text == "扣减原因")[0].Property.Require = isDeduction ? 1 : 0;
			}
			if (name == "申请冻结原因") {
				var isOther = false;
				var option = controlInfo.Config.Selector.Options
					.filter(item => {
						return item.Key == val && item.Value[0].Text.indexOf("其他") > -1;
					})[0];
				if (option != null) {
					isOther = true;
				} else {
					isOther = false;
				}
				var controlBlock = controls.filter(item => item.Property.Title[0].Text == "冻结原因详情")[0];
				controlBlock.Property.Require = isOther && controls.filter(item => item.Property.Title[0].Text == "申请发放原因")[0].Property.Require == 0 ? 1 : 0;
				controlBlock.IsShow = isOther;
			}

			this.$forceUpdate();
		},
		tableOperation(val, type, datas) {
			if (type == 'compute') {
				return;
			}
			this.tableoperation(val, type, datas, this);
		},
		submit() {
			//数据校验
			if (!this.submitValidate(this.templateData.TemplateContent.Controls)) {
				return;
			}
			if (isSubmit) {
				this.Message({
					message: '已提交',
					type: 'warning',
					duration: 1000
				});
				return;
			}
			var SummaryList = [];
			var info = { SummaryInfo: [] }
			info.SummaryInfo = [];
			info.SummaryInfo.push({ "Text": "流水号：流程编号 ", "Lang": "zh_CN" });
			SummaryList.push(info);

			var control2 = this.templateData.TemplateContent.Controls.filter(t => { return t.Property.Title[0].Text == "部门 " })[0]
			var info = { SummaryInfo: [] }
			info.SummaryInfo = [];
			info.SummaryInfo.push({ "Text": "申请部门：" + control2.Value, "Lang": "zh_CN" });
			SummaryList.push(info);

			var control3 = this.templateData.TemplateContent.Controls.filter(t => { return t.Property.Title[0].Text == "申请时间" })[0]
			var info = { SummaryInfo: [] }
			info.SummaryInfo = [];
			info.SummaryInfo.push({ "Text": "申请时间：" + control3.Value, "Lang": "zh_CN" });
			SummaryList.push(info);
			this.templateData.SummaryList = SummaryList;

			isSubmit = true;
			this.formLoading = true;
			//提交
			submitProcess(this.templateId, this.logInfo.EmpNo, this.spNo, this.templateData).then(response => {
				this.Message({
					message: '申请成功',
					type: 'success',
					duration: 3 * 1000
				});
				setTimeout(() => {
					this.$router.push("/index");
				}, 3000)
			}).finally(() => {
				isSubmit = false;
				this.formLoading = false;
			});

		}
	},
	watch: {
		relationList(val, oldVal) {
			if (oldVal == null) {
				this.getTemplate();
			}
		}
	}
}
</script>

<style scoped lang="less">
.pages {
	padding-bottom: 14px;
}
</style>
